import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'

import ContentSection from 'components/ContentSection'
import { Box } from '@piconetworks/ui'
import Subscriptions from './Subscriptions'
import Passes from './Passes'
import DonationBoxes from './DonationBoxes'
import ProductsModule from 'modules/products'

import styles from './Products.module.scss'

const ProductsContainer = ({ children }) => {
    const dispatch = useDispatch()

    const productsLoading = useSelector(ProductsModule.selectors.getProductsLoading)

    const [requestProducts, setRequestProducts] = useState(false)

    useEffect(() => {
        if (!requestProducts && !productsLoading) {
            setRequestProducts(true)
            dispatch(ProductsModule.creators.getProducts())
        }
    }, [dispatch, productsLoading, requestProducts])


    return (
        <ContentSection.Container className={styles.contentWrapper}>
            <Box.Flexbox.Container flexDirection="column" className={styles.container}>
                {children}
            </Box.Flexbox.Container>
        </ContentSection.Container>
    )
}

ProductsContainer.propTypes = {
    children: PropTypes.node,
}

const SubscriptionsSection = () => <ProductsContainer><Subscriptions/></ProductsContainer>
const PassesSection = () => <ProductsContainer><Passes/></ProductsContainer>
const DonationBoxesSection = () => <ProductsContainer><DonationBoxes/></ProductsContainer>

export {
    SubscriptionsSection,
    PassesSection,
    DonationBoxesSection
}
